import type { TypeAlertVariant } from '../types';

import { ALERT_VARIANTS } from './constants';

// ----------------------------------------------------------------------------

function isAlertType(type: string): type is TypeAlertVariant {
    return ALERT_VARIANTS.includes(type as TypeAlertVariant);
}

// ----------------------------------------------------------------------------

export default isAlertType;
